import React from "react";
import Table from "../Components/Table";
function Management({ children, toggleLanguage }) {

  return (
    <>
      <div>
        {/* <Searchbar/> */}
        <div>
          <Table toggleLanguage={toggleLanguage} />
        </div>
      </div>
    </>
  );
}

export default Management;
